module.exports = __webpack_public_path__ + "static/media/15.0c1658ab.png";